/**
 * SSOT — לינקים חיצוניים (Morning / mrng.to) להגדרת אמצעי תשלום / מנוי לפי חבילה.
 * Flow «הגדר אמצעי תשלום» — ללא Hyp payment page דינמי אצלנו.
 */

const DEFAULT_EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS = Object.freeze({
  BASIC: "https://mrng.to/slcXaKPQtc",
  PRO: "https://mrng.to/bTaYlvE7VJ",
  AGENCY: "https://mrng.to/FnmaF9eSLu",
});

function envLink(key) {
  const raw = import.meta.env[key];
  const s = raw != null ? String(raw).trim() : "";
  return s || null;
}

/** קישורים קבועים לפי tier — override דרך VITE_AGENT_SUBSCRIPTION_PAYMENT_LINK_* */
export const EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS = Object.freeze({
  BASIC:
    envLink("VITE_AGENT_SUBSCRIPTION_PAYMENT_LINK_BASIC") ||
    DEFAULT_EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS.BASIC,
  PRO:
    envLink("VITE_AGENT_SUBSCRIPTION_PAYMENT_LINK_PRO") ||
    DEFAULT_EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS.PRO,
  AGENCY:
    envLink("VITE_AGENT_SUBSCRIPTION_PAYMENT_LINK_AGENCY") ||
    DEFAULT_EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS.AGENCY,
});

/** Success URL ל-Morning (להגדרה ב-mrng.to) */
export const SUBSCRIPTION_PAYMENT_SUCCESS_PATH = "/he/subscription-payment-success";

export const SUBSCRIPTION_PAYMENT_PACKAGE_SESSION_KEY = "hr_subscription_payment_package";

/** @param {unknown} packageCode */
export function normalizeSubscriptionPackageCodeForPaymentLink(packageCode) {
  const code = String(packageCode || "")
    .trim()
    .toUpperCase();
  if (!code) return null;
  if (code === "STARTER") return "BASIC";
  if (code === "BASIC" || code === "PRO" || code === "AGENCY") return code;
  return null;
}

/**
 * @param {unknown} packageCode BASIC | PRO | AGENCY (או STARTER → BASIC)
 * @returns {string|null}
 */
export function resolveExternalSubscriptionPaymentLink(packageCode) {
  const tier = normalizeSubscriptionPackageCodeForPaymentLink(packageCode);
  if (!tier) return null;
  const link = EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS[tier];
  return link != null && String(link).trim() !== "" ? String(link).trim() : null;
}

/** @returns {{ BASIC: string|null, PRO: string|null, AGENCY: string|null }} */
export function resolveAllExternalSubscriptionPaymentLinks() {
  return {
    BASIC: EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS.BASIC,
    PRO: EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS.PRO,
    AGENCY: EXTERNAL_SUBSCRIPTION_PAYMENT_LINKS.AGENCY,
  };
}

/** לינק חיצוני — אין callback אוטומטי ל-HotelsRiver אלא אם Morning מוגדר כך. */
export const EXTERNAL_SUBSCRIPTION_PAYMENT_CALLBACK_TO_HR = false;
